export enum STATUS {
  ACTIVE,
  ARCHIVE,
  DELETED
}
